import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { CBreadcrumb, CBreadcrumbItem } from '@coreui/react'
import api from 'src/api/api'

const AppBreadcrumbSitio = (props) => {
  const basePath = String(process.env.PUBLIC_URL).trim()
  const { sitio, ruta } = props
  const sitiosStore = useSelector((state) => state.sitiosStore)
  const currentLocation = useLocation().pathname
  let breadcrumbs_raiz = { pathname: basePath + '/inicio', name: 'Portal' }
  let breadcrumbs_padres = []
  if (ruta.split('/').length > 0) {
    let sitios_aux = ruta.split('/')
    let rutas_aux = ''
    sitios_aux.map((_sitio) => {
      rutas_aux += '/' + _sitio
      let sitio_url = sitiosStore.find((sStore) => {
        return sStore.to === basePath + rutas_aux + '/inicio'
      })
      if (sitio_url !== undefined) {
        breadcrumbs_padres.push({ pathname: sitio_url.to, name: sitio_url.name })
      }
    })
  }
  const [breadcrumbs, setBreadcrumbs] = useState([])

  useEffect(() => {
    if (currentLocation.search('noticias') >= 0) {
      setBreadcrumbs([{ pathname: '/noticias', name: 'Noticias' }])
    } else {
      let id = currentLocation.split('/').slice(-1)[0]
      if (typeof id === 'number' || (typeof id === 'string' && Number.isInteger(Number(id)))) {
        api.miga({ id: id }).then((response) => {
          if (response.data.success) {
            setBreadcrumbs([
              {
                pathname: '', //response.data.data.to,
                name: response.data.data.name,
                active: false,
              },
            ])
          }
        })
      }
    }
  }, [currentLocation, basePath, ruta])

  return (
    <CBreadcrumb className="m-0 bread-sitios">
      <CBreadcrumbItem href={breadcrumbs_raiz.pathname} key={0}>
        {breadcrumbs_raiz.name}
      </CBreadcrumbItem>
      {breadcrumbs_padres.map((arbol) => (
        <CBreadcrumbItem href={arbol.pathname} key={1}>
          {arbol.name}
        </CBreadcrumbItem>
      ))}
      {breadcrumbs.map((breadcrumb, index) => {
        return (
          <CBreadcrumbItem
            {...(breadcrumb.pathname !== ''
              ? { href: basePath + '/' + ruta + breadcrumb.pathname, className: 'cursor-pointer' }
              : { disabled: true })}
            active={breadcrumb.active}
            key={index + 2}
          >
            {breadcrumb.name}
          </CBreadcrumbItem>
        )
      })}
    </CBreadcrumb>
  )
}

AppBreadcrumbSitio.propTypes = {
  sitio: PropTypes.string.isRequired,
  ruta: PropTypes.string.isRequired,
}

export default React.memo(AppBreadcrumbSitio)
